import { Component, ElementRef, HostListener, Input, OnDestroy, OnInit } from "@angular/core";
import { ContextMenuService } from "../../services/context-menu.service";
import { Subscription } from "rxjs";

@Component({
  selector: "app-context-menu",
  templateUrl: "./context-menu.component.html",
  styleUrls: ["./context-menu.component.scss"],
})
export class ContextMenuComponent implements OnInit, OnDestroy {
  @Input() isDisabled = false;
  @Input() color: string | "white" | "dark" = "dark";
  @Input() position: string | "left" | "right" = "right";
  @Input() yPosition: "top" | "bottom" = "bottom";

  isOpenMenu = false;

  subs: Subscription[] = [];

  @HostListener("document:click", ["$event"])
  clickOut(event: MouseEvent) {
    this.yPosition = "bottom";
    if (window.innerHeight < event.clientY + 250) {
      this.yPosition = "top";
    }

    if (!this.eRef.nativeElement.contains(event.target)) {
      this.isOpenMenu = false;
    }
  }

  constructor(
    private eRef: ElementRef,
    private contextMenuService: ContextMenuService
  ) {}

  ngOnInit() {
    this.subs.push(
      this.contextMenuService.statusMenu$.subscribe({
        next: (res) => {
          this.isOpenMenu = res;
        },
      })
    );
  }

  ngOnDestroy() {
    this.subs.forEach((item) => item.unsubscribe());
  }

  openMenu() {
    if (!this.isDisabled) {
      this.isOpenMenu = !this.isOpenMenu;
    }
  }
}
